module.exports = __webpack_public_path__ + "la.svg?80930d5a3a941d9d7d6ac1aa5e1a5116";